import React, {useMemo} from 'react';
import cn from 'classnames';

import createCtx from 'coreUtils/createCtx';

import Link from 'brandComponents/Link';

import {IContentCardProps} from './IContentCard';
import {
	ContentCardDescription,
	ContentCardImages,
	ContentCardInnerWrapper,
	ContentCardLinks,
	ContentCardSubtitles,
	ContentCardTitle,
} from './Subcomponents';

import styles from './ContentCard.module.scss';

export const [useContentCardContext, ContentCardProvider] = createCtx<{
	style: IContentCardProps['style'];
}>();

const ContentCard = (props: IContentCardProps) => {
	const providerValue = useMemo(() => ({style: props.style || 'default'}), []);

	return (
		<ContentCardProvider value={providerValue}>
			<div className={cn(styles['content-card'], 'content-card', props.style, props.classNames)}>
				{!!props.link && <Link to={props.link} className={cn(styles['content-card__link'])} />}
				{props.children}
			</div>
		</ContentCardProvider>
	);
};

ContentCard.Description = ContentCardDescription;
ContentCard.Images = ContentCardImages;
ContentCard.InnerWrapper = ContentCardInnerWrapper;
ContentCard.Links = ContentCardLinks;
ContentCard.Subtitles = ContentCardSubtitles;
ContentCard.Title = ContentCardTitle;

export default ContentCard;
